//# sourceMappingURL=my-calendar-view-changed.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/interfaces/my-calendar-view-changed.interface.js
// module id = 1193
// module chunks = 10